import { bl_del_shipment_import_file_hdr_RowClass } from '../../../../dbschema';
import { BaseContainerModel } from '../../../base-container.model';

export class DeliveryShipmentImportContainerModel extends BaseContainerModel {
  bl_del_shipment_import_file_hdr: bl_del_shipment_import_file_hdr_RowClass = new bl_del_shipment_import_file_hdr_RowClass();
}